import { useEffect, useRef, useState } from 'react';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { replaceSingleH1TagWithH2Tag } from './addH1TagsUtils';
import { AddH1TagsView } from './AddH1TagsView';
import { useTracker } from '../../../context/hooks';
import { AutoFixButton } from './AutoFixButton';
import { H1AutoFixList } from './H1AutoFixList';
import { H1TextContent } from './H1TextContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const isAutofixableH1 = (moduleBody, h1InnerHTML, h1TextContent) => {
  if (h1TextContent === '') {
    return false;
  }
  const isH1InARichTextModule = moduleBody['path'] === '@hubspot/rich_text';
  if (!isH1InARichTextModule) {
    return false;
  }
  const isMatchBetweenH1innerHTMLAndModuleHTML = moduleBody['html'].includes(h1InnerHTML);
  if (!isMatchBetweenH1innerHTMLAndModuleHTML) {
    return false;
  }
  return true;
};
const AutoFixButtonWrapper = ({
  h1Element,
  allModules,
  onClick
}) => {
  const {
    moduleId,
    textContent,
    innerHTML
  } = h1Element;
  if (!moduleId) {
    return null;
  }
  const moduleWithH1 = allModules[moduleId];

  // an example of when there would be no module is when
  // the h1 is in a module which is nested in a global partial
  if (!moduleWithH1 || !moduleWithH1['body']) {
    return null;
  }
  const moduleBody = moduleWithH1['body'];
  if (!isAutofixableH1(moduleBody, innerHTML, textContent)) {
    return null;
  }
  return /*#__PURE__*/_jsx(AutoFixButton, {
    onClick: () => {
      onClick(moduleId, replaceSingleH1TagWithH2Tag(moduleBody['html'], innerHTML));
    }
  });
};
const PagesH1AutoFixListWrapper = ({
  h1Elements,
  allModules,
  updateRichTextModule
}) => {
  const {
    track
  } = useTracker();
  const [isLoading, toggleLoading] = useState(false);
  const previousH1Elements = useRef(h1Elements);
  const showLoader = isLoading || !allModules;
  useEffect(() => {
    if (isLoading && previousH1Elements.current !== h1Elements) {
      toggleLoading(false);
    }
    previousH1Elements.current = h1Elements;
  }, [isLoading, previousH1Elements, h1Elements]);
  const handleClick = (moduleId, updatedHTML) => {
    updateRichTextModule(moduleId, {
      html: updatedHTML
    }, {
      metaData: {
        inlineEdited: false
      },
      undoData: {
        splitNext: true
      }
    });
    toggleLoading(true);
    track('clickedFixLink', {
      recommendationType: 'FIX_H1_TAGS'
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "h1-auto-fix-list",
    style: {
      position: 'relative'
    },
    children: [showLoader && /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered"
    }), !showLoader && /*#__PURE__*/_jsx(H1AutoFixList, {
      listItems: h1Elements.map((h1, i) => {
        return /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx(H1TextContent, {
            textContent: h1.textContent
          }), /*#__PURE__*/_jsx(AutoFixButtonWrapper, {
            h1Element: h1,
            allModules: allModules,
            onClick: handleClick
          })]
        }, i);
      })
    })]
  });
};
export const FixH1TagsPagesView = ({
  auditResult,
  editorApi
}) => {
  const {
    mergeModuleBody
  } = editorApi;
  const {
    h1Elements,
    allModules
  } = auditResult;
  const showAutoFixList = h1Elements && h1Elements.length > 1;
  return /*#__PURE__*/_jsx(AddH1TagsView, {
    auditResult: auditResult,
    autofixList: showAutoFixList && /*#__PURE__*/_jsx(PagesH1AutoFixListWrapper, {
      h1Elements: h1Elements,
      allModules: allModules,
      updateRichTextModule: mergeModuleBody
    })
  });
};